import { Box } from '@mui/material';

import { Chat } from './components/Chat';
import { Disclaimer } from './components/Disclaimer';
import { History } from './components/History';
import { DialogProvider } from './providers/DialogProvider';
import { ParentHelperProvider } from './providers/ParentHelperProvider';
import { SnackbarProvider } from './providers/SnackbarProvider';

import type { FC } from 'react';

export const ParentHelper: FC = () => (
  <ParentHelperProvider>
    <SnackbarProvider>
      <DialogProvider>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { lg: '1fr 264px' },
            gap: 3,
          }}
        >
          <Chat />
          <History />
          <Disclaimer />
        </Box>
      </DialogProvider>
    </SnackbarProvider>
  </ParentHelperProvider>
);
